module.exports = __webpack_public_path__ + "img/prize-01-pic.5249cb4b.png";